import { Project } from '@applicator/shared'

export type ProjectBullet = NonNullable<Project['bulletPoints']>[number]

export function defaultNewProject(id?: string): Project {
  return {
    id: id ?? `project-${Date.now()}`,
    name: '',
    company: '',
    startDate: '',
    endDate: '',
    description: '',
    bulletPoints: [],
    included: true,
  }
}

export function defaultNewProjectBullet(id?: string): ProjectBullet {
  return {
    id: id ?? `project-bullet-${Date.now()}`,
    text: '',
    included: true,
  }
}

/** Legacy description blobs → editable bullet rows. */
export function normalizeProjectForEditor(project: Project): Project {
  const existing = project.bulletPoints ?? []
  if (existing.length > 0) {
    return { ...project, bulletPoints: existing }
  }

  const description = (project.description ?? '').trim()
  if (!description) {
    return { ...project, bulletPoints: [] }
  }

  const segments = description
    .split(/\n+/)
    .flatMap((line) => line.split(/(?<=[.!?])\s+(?=[A-Z])/))
    .map((segment) => segment.trim())
    .filter(Boolean)

  return {
    ...project,
    bulletPoints: segments.map((text, index) => ({
      id: `${project.id}-bullet-${index}`,
      text,
      included: true,
    })),
    description: '',
  }
}

export function normalizeProjectsForEditor(projects: Project[]): Project[] {
  return projects.map(normalizeProjectForEditor)
}

export function projectsNeedEditorNormalization(projects: Project[]): boolean {
  return projects.some((project) => {
    const hasBullets = (project.bulletPoints?.length ?? 0) > 0
    const hasDescription = Boolean((project.description ?? '').trim())
    return !hasBullets && hasDescription
  })
}
